// Tiny display-side formatting helpers shared across admin pages.

// titleCase: URA strings live UPPERCASE in DB by the ingest convention
// (memory: feedback_ura_titlecase_display — never mutate raw DB rows).
// Title-cases at display time without touching numbers or punctuation,
// so "BUKIT TIMAH" → "Bukit Timah" and "99 YEARS FROM 30/01/2020" →
// "99 Years From 30/01/2020". Postal codes (all digits) round-trip
// unchanged because the regex only matches a-z.
export function titleCase(s: string | null | undefined): string {
  if (s == null) return "";
  return s.toLowerCase().replace(/\b([a-z])/g, (m) => m.toUpperCase());
}
